import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { ModuleManifest } from '@buildex/module-contract';

const commonRu = {
  appName: 'BuildEX',
  'login.title': 'Вход в кабинет',
  'login.email': 'Email',
  'login.password': 'Пароль',
  'login.submit': 'Войти',
  'login.sso': 'Войти через BuildEX ID',
  'login.error': 'Не удалось войти. Проверьте email и пароль.',
  logout: 'Выйти',
  'notFound.title': 'Страница не найдена',
  'notFound.text': 'Раздел не существует или модуль не подключён вашей компании.',
  'noModules.title': 'Нет активных модулей',
  'noModules.text':
    'Вашей компании пока не подключён ни один модуль. Обратитесь к менеджеру BuildEX.',

  // Главная
  'home.menu': 'Главная',
  'home.title': 'Главная',
  'home.subtitle':
    'Сводные данные и список объектов. Выберите объект — и пройдите шаги запуска по порядку.',

  // «Дорожка» запуска объекта
  'launch.title': 'Запуск объекта',
  'launch.noObject': 'Объект не выбран — выберите его в списке ниже.',
  'launch.current': 'Текущий объект',
  'launch.refresh': 'Обновить',
  'launch.error': 'Не удалось получить статус объекта',
  'launch.step1.title': 'Шахматка',
  'launch.step1.desc': 'Создать объект и загрузить помещения',
  'launch.step2.title': 'Цены',
  'launch.step2.desc': 'Заполнить стартовые цены (СЦО)',
  'launch.step3.title': 'ДЦО',
  'launch.step3.desc': 'Настроить динамическое ценообразование',
  'launch.done': 'Готово',
  'launch.partial': 'С ценой {{done}} из {{total}}',
  'launch.pending': 'Не пройден',
  'launch.locked': 'Сначала пройдите предыдущий шаг',
  'launch.noModule': 'Модуль этого шага не подключён вашей компании',
  'launch.units': 'Помещений: {{n}}',
  'launch.open': 'Перейти',
  'launch.cta.start': 'Запустить проект',
  'launch.cta.continue': 'Продолжить запуск',
  'launch.cta.done': 'Объект запущен',
};

export function initI18n(): void {
  void i18n.use(initReactI18next).init({
    lng: 'ru',
    fallbackLng: 'ru',
    defaultNS: 'common',
    ns: ['common'],
    resources: {
      ru: { common: commonRu },
    },
    interpolation: { escapeValue: false },
  });
}

/** Словари модуля — в неймспейс по id модуля: dco:*, sco:* (§3 стека) */
export function registerModuleLocales(manifest: ModuleManifest): void {
  if (!manifest.locales) return;
  for (const [lng, dict] of Object.entries(manifest.locales)) {
    i18n.addResourceBundle(lng, manifest.id, dict, true, true);
  }
}
